import { Editor } from 'slate-react';
import React, { useMemo, useRef } from 'react';

import CapitalizeFirstWord from 'components/text_editor/plugins/capitalize_first_word';
import CapitalizeI from 'components/text_editor/plugins/capitalize_i';
import FocusPlugin, { useFocusOnMount } from 'components/text_editor/plugins/focus';
import SelectionPlugin from 'components/text_editor/plugins/selection';
import { usePlaceholder } from 'components/text_editor/placeholder';

export default function TaskCommentSlateEditor({
  autoFocus,
  className,
  editorRef,
  onChange,
  onKeyDown,
  placeholder,
  plugins,
  value,
}) {
  const placeholderElement = usePlaceholder(placeholder);
  editorRef = useEditorRef(editorRef);
  useFocusOnMount(editorRef.current, onChange, autoFocus);

  const allPlugins = usePlugins(() => [
    CapitalizeI(),
    CapitalizeFirstWord(),
    FocusPlugin(),
    SelectionPlugin(),
    ...plugins,
  ]);

  return (
    <Editor
      autoFocus={autoFocus}
      className={className}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholderElement}
      plugins={allPlugins}
      ref={editorRef}
      value={value}
    />
  );
}

TaskCommentSlateEditor.defaultProps = {
  autoFocus: true,
  plugins: [],
};

export function useEditorRef(editorRef) {
  const ref = useRef(null);
  return editorRef ? editorRef : ref;
}

export function usePlugins(pluginFunc, inputs = []) {
  return useMemo(pluginFunc, inputs);
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/task_comments/task_comment_slate_editor.jsx